module.exports = __webpack_public_path__ + "img/google.912eaad4.png";